import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, RejectReason, RejectReasonStatus, RejectReasonUpsert } from '../types'

const BASE = '/management/ticket-reject-reasons'

/** Silinmemiş gerekçelerin (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getRejectReasons(): Promise<PagedResponse<RejectReason>> {
  const { data } = await apiClient.get<PagedResponse<RejectReason>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni gerekçe oluştur (201 → oluşturulan kayıt). */
export async function createRejectReason(body: RejectReasonUpsert): Promise<RejectReason> {
  const { data } = await apiClient.post<RejectReason>(BASE, body)
  return data
}

/** Gerekçeyi güncelle (ad; optimistic lock modDate zorunlu). */
export async function updateRejectReason(
  id: number,
  body: RejectReasonUpsert,
): Promise<RejectReason> {
  const { data } = await apiClient.put<RejectReason>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeRejectReasonStatus(
  id: number,
  body: RejectReasonStatus,
): Promise<RejectReason> {
  const { data } = await apiClient.put<RejectReason>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteRejectReason(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderRejectReasons(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Bilet ret gerekçelerini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportRejectReasons(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'ret-gerekceleri.xlsx')
}
